import { QueryParamAdapterComponent } from 'use-query-params';

export const NullAdapter: QueryParamAdapterComponent = ({ children }) => {
  return children({
    replace() {},
    push() {},
    location: { search: '' },
  });
};
